<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Partner"
            bc1="App"
            bc2="Partner"
            bc3="List"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <h5 class="card-header">Search Filter</h5>
          <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
            <div class="col-lg-4 mb-1 col-sm-12">
              <input class="form-control" @keyup.enter="onSubmitFilters" type="text" v-model="search" placeholder="Search here..."/>
            </div>
            <div class="col-lg-3 mb-1 col-sm-12">
              <select class="form-control" v-model="status">
                <option value="">Select Status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>
            <div class="col-lg-4 mb-1 col-sm-12">
              <button type="button" class="btn btn-primary" @click="onSubmitFilters">Search</button>
              <button type="button" class="ml-1 btn btn-danger " @click="clear">Clear</button>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Partners List</h5>
            <button type="button" class="btn btn-primary" @click="showOnboardModal = true">
              Onboard Partner
            </button>
          </div>
          <CommonTable
            :url="url"
            :tableHeaderValues="tableHeaderValues"
            :actions="actions"
            :deleteActions="deleteActions"
            :mutedData="mutedData"
            :storageKey="storageKey"
            :externalTotalRecord="externalTotalRecord"
            :filteredData="filteredData"
            @getFullResponse="getFullResponse"
            :show-per-page="true"
          />
        </div>
      </div>
    </div>
    <PartnerReferralCodesModal
      :show="showReferralCodesModal"
      :partner="selectedPartner"
      @hide="showReferralCodesModal = false"
      @updated="onReferralCodesUpdated"
    ></PartnerReferralCodesModal>
    <OnboardPartnerModal
      :show="showOnboardModal"
      @hide="showOnboardModal = false"
      @partnerCreated="onPartnerCreated"
    ></OnboardPartnerModal>
    <UpdatePartnerModal
      :show="showUpdateModal"
      :partner="editingPartner"
      @hide="showUpdateModal = false"
      @partnerUpdated="onPartnerUpdated"
    ></UpdatePartnerModal>
  </div>
  <!-- END: Content-->
</template>

<script>
import PartnerReferralCodesModal from "@/pages/dashboard/partners/PartnerReferralCodesModal";
import OnboardPartnerModal from "@/pages/dashboard/partners/OnboardPartnerModal";
import UpdatePartnerModal from "@/pages/dashboard/partners/UpdatePartnerModal";

export default {
  props: ['propFilters'],
  components: {PartnerReferralCodesModal, OnboardPartnerModal, UpdatePartnerModal},
  mounted() {
    localStorage.setItem("url", "v1/get-partners");
    this.checkDataInStore('v1/get-partners')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }

    if (typeof (this.propFilters) != 'undefined' || this.$store.getters.getPartnerPersistFilters != null) {
      let propFilters = this.propFilters

      if (this.$store.getters.getPartnerPersistFilters != null) {
        propFilters = this.$store.getters.getPartnerPersistFilters
      }

      let filterData = {details: 1, settlementConfiguration: 1}

      if (propFilters.currentPage) {
        filterData.page = propFilters.currentPage
      }
      if (propFilters.search) {
        this.search = propFilters.search
        filterData.search = this.search
      }
      if (propFilters.status != '' && typeof (propFilters.status) != 'undefined') {
        this.status = propFilters.status
        filterData.status = this.status
      }

      this.filteredData = filterData
    }
  },
  data() {
    return {
      currentPage: 1,
      search: "",
      url: "v1/get-partners",
      storageKey: "partners",
      status: "",
      filteredData: {details: 1, settlementConfiguration: 1},
      showReferralCodesModal: false,
      showOnboardModal: false,
      showUpdateModal: false,
      selectedPartner: null,
      editingPartner: null,
      force: false,
      tableHeaderValues: [
        {
          title: "UUID",
          valueKey: "uuid",
          html: true,
          alter: (value, row) => {
            var html = "";
            if (value) {
              html = `<span class="text-primary">${value}</span>`;

              if (row.created_by) {
                html = `
                <div class="row">
                <div class="col-12">
                ${html}
                </div><p><div class="badge badge-light-dark ml-1" style="margin-top: 0.3rem">${row.created_by.email + '/' + row.created_by.first_name}</div></p></div>`
              }
            } else {
              html = "-";
            }

            return html;
          }
        },
        {
          title: "First Name",
          valueKey: "first_name",
          alter: function (value) {
            return value ? value : "-";
          }
        },
        {
          title: "Last Name",
          valueKey: "last_name",
          alter: function (value) {
            return value ? value : "-";
          }
        },
        {
          title: "Business Name",
          valueKey: "business_name",
          alter: function (value) {
            return value ? value : "-";
          }
        },
        {
          title: "Email",
          valueKey: "email",
          alter: function (value) {
            return value ? value : "-";
          }
        },
        {
          title: "Phone",
          valueKey: "phone_number",
          alter: function (value) {
            return value ? value : "-";
          }
        },
        {
          title: "Referral Codes",
          valueKey: "referral_codes",
          html: true,
          alter: (value) => {
            let count = Array.isArray(value) ? value.length : 0
            return `<button type="button" class="btn btn-sm badge-light-primary badge d-flex align-items-center">
                      Manage
                      <span class="badge badge-warning ml-50">${count}</span>
                    </button>`;
          },
          cta: (row) => {
            this.selectedPartner = row
            this.showReferralCodesModal = true
          }
        },
        {
          title: "Created Date / Time",
          valueKey: "created_at",
          alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
        {
          title: "Status",
          valueKey: "status",
          html: true,
          alter: (value) => {
            var html = "";

            if (value == 1) {
              html = `<span class="badge badge-success badge-glow badge-sm">Active</span>`;
            } else {
              html = `<span class="badge badge-danger badge-glow badge-sm">Inactive</span>`;
            }

            return html;
          }
        }
      ],
      actions: [
        {
          title: 'Details',
          class: 'btn-primary mt-1',
          cta: (row, index) => {
            this.$store.dispatch("set", {
              index: index,
              row: row,
              key: "partnerDetails"
            });

            let propFilters = {
              search: this.search,
              status: this.status,
              currentPage: this.currentPage
            }

            this.$router.push({name: 'partner-detail', params: {id: row.id, propFilters: propFilters}})
          }
        },
        {
          title: 'Edit',
          class: 'btn-warning mt-1',
          cta: (row) => {
            this.editingPartner = row
            this.showUpdateModal = true
          }
        },
        // {
        //   title: "Settlement Configuration",
        //   class: 'badge btn-primary mt-1',
        //   cta: (row, index) => {
        //     let data = {
        //       index: index,
        //       row: row,
        //       key: "partnerSettlementConfiguration"
        //     };
        //     this.$store.dispatch("set", data);
        //
        //     let propFilters = {
        //       search: this.search,
        //       status: this.status,
        //     }
        //     propFilters.currentPage = this.currentPage
        //     this.$store.dispatch("setPartnerPersistFilters", propFilters);
        //
        //     this.$router.push({name: "partner-settlement-configuration", params: {partnerId: row.id}});
        //   }
        // }
      ],
      deleteActions: [],
      mutedData: [],
      externalTotalRecord: "",
    };
  },
  methods: {
    getFullResponse(response) {
      if (typeof (response.fullResponse) != 'undefined') {
        let data = response.fullResponse
        this.currentPage = data.paginationData.currentPage
      }
    },
    onSubmitFilters() {
      let filterData = {details: 1, settlementConfiguration: 1}

      if (this.search != '') {
        filterData.search = this.search
      }
      if (this.status != '') {
        filterData.status = this.status
      }

      this.filteredData = filterData
    },
    clear() {
      this.search = ''
      this.status = ''
      this.filteredData = {details: 1, settlementConfiguration: 1}
    },
    onPartnerCreated() {
      // reset filters so the newly onboarded partner shows up on the first page
      this.clear()
    },
    onPartnerUpdated() {
      // refresh the listing so the edited row reflects the saved values
      this.$store.dispatch('renderPagination', !this.force);
      this.force = !this.force;
    },
    onReferralCodesUpdated() {
      // referral codes were created/updated in the modal, refresh the listing so counts stay in sync
      this.$store.dispatch('renderPagination', !this.force);
      this.force = !this.force;
    }
  },
};
</script>
